<template>
  <div>
    <Modal v-model="newValue" width="360" :scrollable="true">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>消息提示</span>
      </p>
      <div style="text-align:center">
        您的资质认证审核未通过，可到
        <span @click="goAuth(2)" class="link-verify">审核状态</span>
        查看原因
      </div>
      <div slot="footer">
        <div class="btn-box">
          <!-- <Button type="info" @click="goAuth(0)">药企/研发认证</Button> -->
          <Button type="primary" @click="goAuth(1)">患者认证</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ThreeModel",
  data() {
    return {
      newValue: false
    };
  },
  methods: {
    goAuth(index) {
      this.newValue = false;
      if (index === 0) {
        this.$router.push("/company");
      } else if (index === 1) {
        this.$router.push("/patient");
      } else {
        this.$router.push("/home/verifyCenter");
      }
    }
  }
};
</script>

<style scoped>
.link-verify {
  color: red;
  cursor: pointer;
}
</style>
